export default __webpack_public_path__ + "static/media/cogs.6147e4cb.svg";